// React
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Data
import data from "../data";

// Icon
import premiumProductIcon from "../../../../../assets/premium-products-icon-square.svg";
import paperMoneyIcon from "../../../../../assets/paper-money-icon-square.svg";
import chatIcon from "../../../../../assets/chat-icon-square.svg";

// Style
import "./style.css";

class StepThree extends Component {
  reasons = [
    this.props.currentPlan.name === "Promotional"
      ? this.renderReasonOne()
      : this.renderReasonOnePromotional(),
    this.renderReasonTwo(),
    this.renderReasonThree(),
    this.renderReasonFour(),
    this.renderReasonFive(),
    this.renderReasonSix(),
    this.props.currentPlan.name === "Promotional"
      ? this.renderReasonSeven()
      : this.renderReasonSevenPromotional(),
    this.renderReasonEight(),
    this.renderReasonDowngradePromotional()
  ];

  getIndexOfReason() {
    return data.reasonList.findIndex(
      element => element.title === this.props.cancelReason
    );
  }

  findPlan(planType, isAnnual) {
    return this.props.allPlans.find(
      plan => plan.name === planType && plan.annual === isAnnual
    );
  }

  render() {
    return (
      <div className="Step_Three_reason_container">
        {this.reasons[this.getIndexOfReason()]}
      </div>
    );
  }

  /**
   * Reason one = Haven’t made enough sales to justify the cost
   * @return {ReactElement}
   */
  renderReasonOnePromotional() {
    const promotionalPlan = this.findPlan("Promotional", false);
    const currentPlan = this.findPlan(this.props.currentPlan.name, false);
    return (
      <div>
        <div>We get it. Life is expensive.</div>
        <div>
          Claim this one time offer! Get Spocket Pro for{" "}
          <strong>
            ${promotionalPlan.price_plan}0 instead of {currentPlan.price}, for 3
            months!
          </strong>
        </div>
        <div>
          <a
            className="Step_Seven_downgrade_link"
            onClick={this.props.downgradePlan}
          >
            Continue to Downgrade
          </a>
        </div>
      </div>
    );
  }

  renderReasonOne() {
    return (
      <div>
        <div>
          Based on our stats, our users take 30 days to achieve their first
          sale. However, this time frame is shorter for those who pay for the
          Pro Plan.
        </div>
        <br />
        <div>
          <strong>
            Would you like to continue the plan for a month to see the results?
          </strong>
        </div>
      </div>
    );
  }

  /**
   * Reason Two = Didn’t find the products I am looking for
   * @return {ReactElement}
   */
  renderReasonTwo() {
    return (
      <div>
        <div>
          {/* TODO - Get the number of new products by API */}
          On average, we bring in <strong>623 new products</strong> every week.
        </div>
        <br />
        <div>
          You can request new products{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="Step_Three_link"
            href="https://spocket.typeform.com/to/uB36Z0"
          >
            here
          </a>{" "}
          and we will try our best to bring you discounted products with fast
          shipping time.
        </div>
        <br />
        <div>
          <strong>
            Would you like to wait and continue your current plan for a month?
          </strong>
        </div>
      </div>
    );
  }

  /**
   * Reason Three = I won't be selling as many products
   * @return {ReactElement}
   */
  renderReasonThree() {
    return (
      <div>
        <div>
          Wait, That’s not all Spocket has to offer!
          <br />
          Here’s what else you get with the Pro Plan:
        </div>
        <br />
        <div>
          <div className="Step_Three_reason_three">
            <img src={premiumProductIcon} alt="Premium product icon" />
            <span>
              Exclusive & highly discounted <strong>Premium Products</strong>
            </span>
          </div>
          <div className="Step_Three_reason_three">
            <img src={paperMoneyIcon} alt="Paper money icon" />
            <span>
              Customized <strong>Branded Invoices</strong>
            </span>
          </div>
          <div className="Step_Three_reason_three">
            <img src={chatIcon} alt="Chat icon" />
            <span>
              Quick and reliable <strong>chat support</strong>
            </span>
          </div>
        </div>
        <div>
          <strong>
            Would you like to continue your current plan for a month to explore
            all our Pro features?
          </strong>
        </div>
      </div>
    );
  }

  /**
   * Reason Four = Didn’t find enough Premium products
   * @return {ReactElement}
   */
  renderReasonFour() {
    return (
      <div>
        <div>
          On average, we bring in <strong>623 new products</strong> every week!
          A lot of them are premium (exclusive, discounted & fast shipping).
        </div>
        <br />
        <div>
          You can request Premium products{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="Step_Three_link"
            href="https://spocket.typeform.com/to/uB36Z0"
          >
            here
          </a>{" "}
          and we will try our best to bring them on Spocket.
        </div>
        <br />
        <div>
          <strong>
            Would you like to wait and continue your current plan for a month?
          </strong>
        </div>
      </div>
    );
  }

  /**
   * Reason Five = Didn’t get enough time to try the app
   * @return {ReactElement}
   */
  renderReasonFive() {
    return (
      <div>
        <div>
          Spocket Pro has a ton of powerful features used by thousands of
          successful dropshippers.
        </div>
        <br />
        <div>
          <strong>
            Would you like to continue your current plan for a month to explore
            all our Pro features?
          </strong>
        </div>
      </div>
    );
  }

  /**
   * Reason Six = This is temporary, I’ll come back when the time is right
   * @return {ReactElement}
   */
  renderReasonSix() {
    return (
      <div>
        Thank you for your feedback. Please click the button below to Downgrade!
      </div>
    );
  }

  /**
   * Reason Seven = I cannot afford it
   * @return {ReactElement}
   */
  renderReasonSevenPromotional() {
    const promotionalPlan = this.findPlan("Promotional", false);
    const currentPlan = this.findPlan(this.props.currentPlan.name, false);
    return (
      <div>
        <div>We get it. Life is expensive.</div>
        <div>
          Claim this one time offer! Get Spocket Pro for{" "}
          <strong>
            ${promotionalPlan.price_plan}0 instead of {currentPlan.price}, for 3
            months!
          </strong>
        </div>
        <div>
          <a
            className="Step_Seven_downgrade_link"
            onClick={this.props.downgradePlan}
          >
            Continue to Downgrade
          </a>
        </div>
      </div>
    );
  }

  /**
   * I cannot afford it - Promotional
   * We are using it to trigger the <DowngradePlanPromotionalModal>
   * @return {ReactElement}
   */
  renderReasonDowngradePromotional() {
    const promotionalPlan = this.findPlan("Promotional", false);
    const currentPlan = this.findPlan(this.props.currentPlan.name, false);
    return (
      <div>
        Get Spocket Pro for{" "}
        <strong>
          ${promotionalPlan.price_plan}0 instead of {currentPlan.price}, for 3
          months!
        </strong>
      </div>
    );
  }

  renderReasonSeven() {
    return (
      <div>
        <div>
          We get it. Life is expensive. Please click the button below to
          Downgrade.
        </div>
        <br />
        <div>
          <strong>
            Thank you for your feedback. Please click the button below to
            Downgrade!
          </strong>
        </div>
      </div>
    );
  }

  /**
   * Reason Eight = Other
   * @return {ReactElement}
   */
  renderReasonEight() {
    return (
      <div>
        Thank you for your feedback. Please click the button below to Downgrade!
      </div>
    );
  }
}

StepThree.propTypes = {
  cancelReason: PropTypes.string
};

function mapStateToProps(state) {
  return {
    currentPlan: state.settings.currentPlan,
    allPlans: state.store.plans.allPlans
  };
}

export default connect(mapStateToProps)(StepThree);



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/DowngradePlanModal/StepThree/index.js